import { render, staticRenderFns } from "./VehicleBrandModel.vue?vue&type=template&id=fc72fd2e&"
import script from "./VehicleBrandModel.vue?vue&type=script&lang=js&"
export * from "./VehicleBrandModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports